import React, { useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Grid,
    Divider,
    Chip
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import closeIcon from "../../../assets/icons/close.png";
import expandIcon from "../../../assets/icons/expend.png";
import { getPartnerByIdApi } from "../../Services/Partner/Partner";
import { ThreeDot } from "react-loading-indicators";
import oligasIcn from "../../../assets/icons/oligas.png";
import evAutoIcn from "../../../assets/icons/automotive.png";
import power from "../../../assets/icons/power.png";
import aerospace from "../../../assets/icons/aerospace.png";
import industry from "../../../assets/icons/industry.png";
import defaultlogo from "../../../assets/icons/noimg.png";
import { generatePartnerRegistrationFile } from "../../../Utils/Constant";

const industryIcons = {
    "Oil & Gas": oligasIcn,
    "Power & Transmission": power,
    "EV/Automotive": evAutoIcn,
    "Industrial Products": industry,
    "Aerospace & Defence": aerospace
};

const PartnerDetailsDrawer = ({ open, onClose, selectedPartner }) => {
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedRowImage, setSelectedRowImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const industry = selectedRow?.Industry || "";

    const iconSrc = industryIcons[industry];

    const navigate = useNavigate();
    React.useEffect(() => {
        if (selectedPartner) {
            fetchPartnerDetails(selectedPartner?.unique_ID);
            // navigate("/layout/PartnerDatabase");
        }
    }, [selectedPartner]);

    const fetchPartnerDetails = async (uniqueId: string) => {
        setSelectedRowImage(null);
        setSelectedRow(null);
        setLoading(true);
        try {
            const data = await getPartnerByIdApi(uniqueId);
            setLoading(false);

            if (data?.status) {
                const partner = data?.data[0];
                setSelectedRow(partner);
                const logoField = partner?.Upload_Company_Logo_Path || "";
                console.log("logoField", partner);
                // const extractUrl = logoField.split("filepath=");
                // const hasLogo = extractUrl.length > 1 && extractUrl[1]?.trim() !== "";

                const logoUrl = logoField
                    ? generatePartnerRegistrationFile(logoField)
                    : defaultlogo;

                setSelectedRowImage(logoUrl);
            }
        } catch (error) {
            setLoading(false);
        }
    };
    const payload = {
        partner_Id: selectedPartner?.unique_ID,
        navigatingFrom: selectedPartner?.navigatingFrom,
        ID: selectedPartner?.ID,
        rfqID: selectedPartner?.rfqID,
        MMrfq: selectedPartner?.rfqData
    };
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Partner’s Key Details
                    </Typography>
                    <Box>
                        <Link
                            to="/layout/PartnerDetails"
                            target="_blank"
                            state={{payload}}
                            onClick={() => {
                                localStorage.setItem(
                                    "PartnerDetails",
                                    JSON.stringify(payload)
                                );
                            }}
                        >
                            <IconButton>
                                <img
                                    src={expandIcon}
                                    width={20}
                                    alt="Expand"
                                    onClick={onClose}
                                />
                            </IconButton>
                        </Link>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={closeIcon} width={14} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>
                <Divider sx={{ my: 2 }} />
                {loading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100vh" // Ensures it takes up the full height of the viewport
                        }}
                    >
                        <ThreeDot
                            color="#1976d2"
                            size="medium"
                            text=""
                            textColor=""
                        />
                    </Box>
                ) : selectedRow ? (
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Partner Name
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    {selectedRowImage && (
                                        <img
                                            src={selectedRowImage}
                                            width={24}
                                            height={24}
                                            style={{
                                                marginRight: 5,
                                                borderRadius: "50%",
                                                border: "1px solid #d8d8d8"
                                            }}
                                            alt="Logo"
                                        />
                                    )}
                                    {selectedRow?.Legal_Name_of_Business}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Partner ID
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography variant="body2">
                                    {selectedRow?.Partner_ID || "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 2 }} />
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{ mb: 1 }}
                        >
                            Companies Listing
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5} mb={2}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Industry Type
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={7}
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1
                                }}
                            >
                                {Array.isArray(selectedRow?.Industry) &&
                                    selectedRow.Industry.map(
                                        (industry: string, index: number) => {
                                            const iconSrc =
                                                industryIcons[industry];
                                            return (
                                                <Chip
                                                    key={index}
                                                    variant="filled"
                                                    size="small"
                                                    label={
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems:
                                                                    "center"
                                                            }}
                                                        >
                                                            {iconSrc && (
                                                                <img
                                                                    src={
                                                                        iconSrc
                                                                    }
                                                                    alt={
                                                                        industry ||
                                                                        "Industry Icon"
                                                                    }
                                                                    width="14px"
                                                                    height="14px"
                                                                    style={{
                                                                        marginRight:
                                                                            "5px"
                                                                    }}
                                                                />
                                                            )}
                                                            {industry || "-"}
                                                        </span>
                                                    }
                                                />
                                            );
                                        }
                                    )}
                            </Grid>
                        </Grid>
                        {[
                            {
                                label: "Solutions",
                                value: Array.isArray(
                                    selectedRow?.Solutions_You_Offer
                                )
                                    ? selectedRow.Solutions_You_Offer
                                    : [],
                                isChip: true
                            },
                            {
                                label: "Process",
                                value: Array.isArray(
                                    selectedRow?.Processes_Offered
                                )
                                    ? selectedRow.Processes_Offered
                                    : [],
                                isChip: true
                            },
                            {
                                label: "Sub-process",
                                value: Array.isArray(
                                    selectedRow?.Sub_Processes_you_Offer
                                )
                                    ? selectedRow.Sub_Processes_you_Offer
                                    : [],
                                isChip: true
                            },
                            {
                                label: "No. of Factories",
                                value: selectedRow?.No_of_Factories || "-",
                                isChip: false
                            },
                            {
                                label: "Machines available",
                                value: Array.isArray(
                                    selectedRow?.List_of_Top_machines
                                )
                                    ? selectedRow.List_of_Top_machines.map(
                                          (m) => m.Machine_category || "-"
                                      )
                                    : [],
                                isChip: true
                            },
                            {
                                label: "Year of Founding",
                                value: selectedRow?.Year_of_Founding || "-",
                                isChip: false
                            },
                            {
                                label: "Address",
                                value:
                                    selectedRow?.Principal_Place_of_Business ||
                                    "-",
                                isChip: false
                            }
                        ].map((item, index) => (
                            <Grid container spacing={2} key={index}>
                                <Grid item xs={12} md={5}>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        mt={2}
                                    >
                                        {item.label}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={7} mt={2}>
                                    {item.isChip ? (
                                        item.value.length > 0 ? (
                                            item.value.map((val, idx) => (
                                                <Chip
                                                    key={idx}
                                                    label={val}
                                                    size="small"
                                                    style={{
                                                        marginRight: 4,
                                                        marginBottom: 4
                                                    }}
                                                />
                                            ))
                                        ) : (
                                            <Typography variant="body2">
                                                -
                                            </Typography>
                                        )
                                    ) : (
                                        <Typography variant="body2">
                                            {item.value}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        ))}

                        <Divider sx={{ my: 2 }} />
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{ mb: 1 }}
                        >
                            Certifications
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={2}
                                >
                                    Certifications
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography variant="body2">
                                    {selectedRow?.Certifications?.length
                                        ? selectedRow.Certifications.map(
                                              (item) =>
                                                  item?.Certificate_Name || "-"
                                          ).join(", ")
                                        : "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider sx={{ my: 2 }} />
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{ mb: 1 }}
                        >
                            Financial Overview
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={2}
                                >
                                    Average Company Turnover
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography variant="body2">
                                    {selectedRow?.Average_Company_Turnover ||
                                        "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={2}
                                >
                                    Credit Period you can Offer
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography variant="body2">
                                    {selectedRow?.Credit_Period_you_can_Offer ||
                                        "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                ) : (
                    <Typography variant="body2">No Data Found</Typography>
                )}
            </Box>
        </Drawer>
    );
};

export default PartnerDetailsDrawer;
